module.exports = __webpack_public_path__ + "img/IMEC-EXPO-logo.d23b180f.jpg";